import { gql } from 'apollo-boost';

export const LIST_API_TOKENS = gql`
    query ListApiTokens {
        listApiTokens {
            id
            name
            prefix
            scopes
            createdAt
            lastUsedAt
            expiresAt
        }
    }
`;
